/* @flow */
import produce from 'immer';
import { actionTypes } from './actions';

const { SAVE_COORDINATES, SAVE_ZOOM } = actionTypes;

type State = {
  zoom: number,
  center: CoordinatesT,
};

const initialState = {
  zoom: 7,
  center: {
    lat: 35.77,
    lng: -119.41,
  },
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case SAVE_COORDINATES:
        draft.center = action.payload;
        return;
      case SAVE_ZOOM:
        draft.zoom = action.payload;
    }
  });
